import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { APP_ROUTES } from '../constants/routes'
import { translations } from '../i18n'
import { useThemeStore } from './data/stores/theme.store'
import Account from './modules/account/account'
import SignOut from './modules/sign-out/sign-out'
import SignIn from './modules/sign-in/sign-in'
import SignUp from './modules/sign-up/sign-up'
import Tokens from './modules/tokens/tokens'
import Verify from './modules/verify/verify'
import { Toaster } from 'react-hot-toast'
import AppLayout from '../app/layout/app-layout'
import { LocalizationProvider } from '@racefront/common/context/localization-context'
import { getInitialLocale } from '@racefront/common/i18n'
import AuthWrapper from './auth-wrapper'
import { usePageTracking } from './data/hooks/useGoogleAnalytics'
import CheckAuth from './modules/check-auth/check-auth'
import { ConfigCatProvider, createConsoleLogger, LogLevel, PollingMode } from 'configcat-react'
import { useUserLocaleSync } from './data/hooks/use-user-locale-sync'

function UserLocaleSync() {
  useUserLocaleSync()
  return null
}

export function App() {
  const { theme } = useThemeStore()

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.add(theme)
  }, [theme])

  const initialLocale = getInitialLocale()
  usePageTracking()

  const logger = createConsoleLogger(LogLevel.Info)

  return (
    <ConfigCatProvider
      sdkKey={import.meta.env.VITE_CONFIGCAT_SDK_KEY}
      pollingMode={PollingMode.AutoPoll}
      options={{ logger, pollIntervalSeconds: 86400 }} // Poll every 24 hours
    >
      <LocalizationProvider initialLocale={initialLocale} translations={translations}>
        <UserLocaleSync />
        <Toaster toastOptions={{ id: 'toast-message', className: 'toast-message' }} />
        <Routes>
          <Route path="/" element={<AuthWrapper />}>
            <Route path="/" element={<Navigate to={APP_ROUTES.SignIn} replace />} />
            <Route path={APP_ROUTES.SignIn} element={<SignIn />} />
            <Route path={APP_ROUTES.SignUp} element={<SignUp />} />
            <Route path={APP_ROUTES.Verify} element={<Verify />} />
          </Route>
          <Route path={APP_ROUTES.Account} element={<AppLayout />}>
            <Route path={APP_ROUTES.Account} element={<Account />} />
          </Route>
          <Route path={'/embedded/account'} element={<Account />} />
          <Route path={APP_ROUTES.Check} element={<CheckAuth />} />
          <Route path={APP_ROUTES.Tokens} element={<Tokens />} />
          <Route path={APP_ROUTES.SignOut} element={<SignOut />} />
        </Routes>
      </LocalizationProvider>
    </ConfigCatProvider>
  )
}

export default App
